import React, {useState, useEffect, useContext} from 'react';
import bs58 from 'bs58';

import styles from './ConnectWalletHeader.module.css';
import email_svg from '../../static_files/connect-email.svg';

import okx_icon from '../../static_files/OKX-icon.svg';
import coinbase_icon from '../../static_files/Coinbase-icon.svg';
import walletconnect_icon from '../../static_files/walletconnect-icon.svg';
import Phantom_icon from '../../static_files/Phantom Wallet.svg';

import okx_icon_mobile from '../../static_files/OKX Wallet.png';
import coinbase_icon_mobile from '../../static_files/Coinbase-icon.png';
import walletconnect_icon_mobile from '../../static_files/walletconnect-icon.png';
import Phantom_icon_mobile from '../../static_files/Phantom Wallet.png';

import menu_icon from "../../static_files/menu.svg";
import logo_svg from "../../static_files/PrismaxLogoWhite.svg";
import rejectImg from '../../static_files/rejectImg.svg';
import cancle_icon from '../../static_files/cancel.svg';
import successImg from '../../static_files/successImg.svg';
import warningImg from '../../static_files/warningImg.svg';
import disconnectImg from '../../static_files/disconnect.svg';
import emailLogoutImg from "../../static_files/emailLogout.svg";
import menuDropDownImg from '../../static_files/MenuDropDown.svg'
import {
    fetchBalancesAndNotifyParent,
    getTokenAccountFromWalletAddress,
    fetchTokenBalances,
    chains,
    metadata,
    projectId, fetchThreeTokenBalancesWithoutProvider,
} from './ConnectWalletHeaderOnchainHelper';
import {
    Connection,
    PublicKey,
    Transaction,
    TransactionInstruction
} from '@solana/web3.js';

// Email login
import {useAuth} from '../../context/AuthContext';

// wallet connect
import {useWeb3Modal, createWeb3Modal, defaultSolanaConfig} from '@web3modal/solana/react';
import {solana} from '@web3modal/solana/chains';
import {useWeb3ModalAccount} from '@web3modal/solana/react';
import {useWeb3ModalProvider} from '@web3modal/solana/react';


import {
    getOrCreateAssociatedTokenAccount,
    createTransferInstruction,
} from '@solana/spl-token';
import SideMenu from "./MobileMenu";
import {SwapMainAppContext} from "../../context/SwapMainAppContext";
import {APP_URL, PRISMAX_BACKEND_URL, RPC_URL} from "../../configs/config";
import {useRecaptcha} from "../../utils/useRecaptcha";


/**
 * Props:
 *  - onWalletConnected : pass out Component， let parent know the address + balance
 *  - amount: user input mint/redeem amount
 *  - transactionTrigger: transaction triggered?
 *  - selectedToken: what transaction token is being used
 */


// For wallet connect modal
createWeb3Modal({
    solanaConfig: defaultSolanaConfig({
        metadata,
        defaultChain: solana,
        enableInjected: true // Optional - defaults to true
    }), // required
    chains, // required
    projectId,
    enableAnalytics: true, // Optional - defaults to your Cloud configuration,
});

const ConnectWalletHeader = ({
                                 onWalletConnected,
                                 showPanel,
                                 setShowPanel,
                                 requireSignature = false, // signin for admin page
                                 adminWhitelist = [],       // for admin page,
                                 setAdminLogin,
                                 setAdminAccessToken
                             }) => {
    const {
        notification, showNotification,
        usdtTokenAddress,
        usdcTokenAddress,
        prismaxRecevingAddress,
        transactionTrigger,
        selectedToken,
        amount,
        onMembershipPaymentSuccess,
        userEmail,
        setUserEmail,
        setUserClass,
        setIsProcessing,
        setUsdcBalance,
        setUsdtBalance,
        setGatewayToken,
        clearUserData,
        setUserId
    } = useContext(SwapMainAppContext);
    const {
        walletAddress: connectedPublicKey,
        // rename setWalletAddress to setConnectedPublicKey locally
        //    connectedPublicKey =  complete address
        setWalletAddress: setConnectedPublicKey,
    } = useContext(SwapMainAppContext);
    // Track which wallet is connected
    const [connectedWalletType, setConnectedWalletType] = useState(null);
    // Shorten version address
    const [walletAddress, setWalletAddress] = useState(() => {
        const storedAddress = connectedPublicKey;
        return storedAddress ? shortenAddress(storedAddress) : 'Connect Wallet';
    });

    const [isSideMenuOpen, setIsSideMenuOpen] = useState(false);
    const [selectedMenuItem, setSelectedMenuItem] = useState('myAssets');


    const [okxSolanaProvider, setOkxSolanaProvider] = useState(null);
    const [coinbaseSolanaProvider, setCoinbaseSolanaProvider] = useState(null);
    const [phantomSolanaProvider, setPhantomSolanaProvider] = useState(null);

    // For wallet Connect
    const [walletConnectProvider, setWalletConnectProvider] = useState(null);
    const {open} = useWeb3Modal();
    const {address: modalAddress} = useWeb3ModalAccount();
    const {walletProvider} = useWeb3ModalProvider();

    // For detecting if the wallet extension has been installed
    const [isOkxDetected, setIsOkxDetected] = useState(false);
    const [isCoinbaseDetected, setIsCoinbaseDetected] = useState(false);
    const [isPhantomDetected, setIsPhantomDetected] = useState(false);

    // Track if auto-reconnection has been attempted to prevent multiple attempts
    const [autoReconnectionAttempted, setAutoReconnectionAttempted] = useState(false);

    //Gat way:
    const {logout, gatewayUserData} = useAuth();
    const {executeRecaptchaAction, isRecaptchaReady} = useRecaptcha();

    const requestSignature = async (provider, publicKey) => {
        const message = "Sign this message to authenticate as admin for PrismaX AI Admin Portal.";
        const encodedMessage = new TextEncoder().encode(message);

        let signature;

        // Handle different wallet types
        if (provider.signMessage) {
            const result = await provider.signMessage(encodedMessage);

            // Check if result is an object with signature property (OKX wallet case)
            if (result && typeof result === 'object' && 'signature' in result) {
                signature = result.signature;
            } else {
                signature = result;
            }
        } else if (provider.request) {
            const response = await provider.request({
                method: 'signMessage',
                params: {
                    message: encodedMessage,
                    display: 'utf8'
                }
            });
            signature = response.signature;
        }

        let signatureBase58;
        if (signature instanceof Uint8Array) {
            signatureBase58 = bs58.encode(signature);
        } else if (typeof signature === 'string') {
            signatureBase58 = signature;
        } else {
            console.error('Unexpected signature type:', typeof signature, signature);
            throw new Error('Unexpected signature format');
        }

        return signatureBase58;
    };
    // wallet Connect Use effect
    useEffect(() => {
        if (modalAddress) {
            setWalletAddress(shortenAddress(modalAddress));
            setConnectedPublicKey(modalAddress);
        }
    }, [modalAddress]);

    useEffect(() => {
        if (walletProvider) {
            if (connectedWalletType !== null) {
                handleWalletConnectSolana();
            }
        }
    }, [walletProvider]);

    // address from email user
    useEffect(() => {
        if ((localStorage.getItem("userEmail") && localStorage.getItem("emailUserWalletAddress") !== "null" && localStorage.getItem("emailUserWalletAddress") !== null && localStorage.getItem("emailUserWalletAddress") !== "requested")) {
            setWalletAddress(shortenAddress(localStorage.getItem("emailUserWalletAddress")));

        } else if (localStorage.getItem("userEmail") && gatewayUserData) {
            setWalletAddress("Connect Wallet");
        }
    }, [gatewayUserData]);

    // -----------------------------------------
    // Use Effect for handling transactions
    // -----------------------------------------
    // Handel Transfer trigger ->
    useEffect(() => {
        const run = async () => {
            try {

                let RECEIVING_TOKEN_ACCOUNT;
                if (selectedToken === 'USDC') {

                    RECEIVING_TOKEN_ACCOUNT = await getTokenAccountFromWalletAddress(
                        prismaxRecevingAddress,
                        usdcTokenAddress
                    );

                } else if (selectedToken === 'USDT') {
                    RECEIVING_TOKEN_ACCOUNT = await getTokenAccountFromWalletAddress(
                        prismaxRecevingAddress,
                        usdtTokenAddress
                    );
                }
                await handleSolanaTransaction(RECEIVING_TOKEN_ACCOUNT);
            } catch (err) {
                console.error('Error recording CASH transaction:', err);
            }
        };
        //todo maybe bug here
        if (transactionTrigger !== 0) {
            run();
        }
    }, [transactionTrigger]);

    // detect  Wallet extension exist?
    useEffect(() => {
        if (window.okxwallet && window.okxwallet.solana) {
            setIsOkxDetected(true);
        }
        if (window.coinbaseSolana) {
            setIsCoinbaseDetected(true);
        }
        let phantomProvider = window.phantom?.solana || window.solana;
        if (phantomProvider && phantomProvider.isPhantom) {
            setIsPhantomDetected(true);
        }
    }, []);


    // Read local storage for last connected wallet - wait for reCAPTCHA to be ready
    useEffect(() => {
        // Only proceed with auto-reconnection if reCAPTCHA is ready and we haven't attempted yet
        if (!isRecaptchaReady || autoReconnectionAttempted) {
            return;
        }

        setAutoReconnectionAttempted(true); // Mark that we've attempted reconnection
        
        const lastWallet = localStorage.getItem('lastConnectedWallet');
        const isEmailLogin = localStorage.getItem('emailUserWalletAddress');
        if (isEmailLogin) {
            // (No action needed: email is already connected)
            fetchThreeTokenBalancesWithoutProvider(isEmailLogin, onWalletConnected);

        } else if (lastWallet === 'okx') {
            handleOKXWalletSolana();
        } else if (lastWallet === 'coinbase') {
            handleCoinbaseWalletSolana();
        } else if (lastWallet === 'phantom') {
            handlePhantomWalletSolana();
        } else if (lastWallet === 'walletconnect') {
            handleWalletConnectSolana();
        }
    }, [isRecaptchaReady, autoReconnectionAttempted]); // Add both dependencies


    // -----------------------------------------
    // UTILITY
    // -----------------------------------------
    const handleConnectWalletClick = (e) => {
        e.stopPropagation();
        setShowPanel((prev) => !prev);
    };
    const closePanel = () => setShowPanel(false);
    const stopPropagation = (e) => e.stopPropagation();
    const handleOutsideClick = () => {
        if (showPanel) closePanel();
    };
    const handleMenuIconClick = (e) => {
        e.stopPropagation();
        setIsSideMenuOpen(true);
    };
    const handleOutsideClickSideMenu = () => {
        setIsSideMenuOpen(false);
    };
    const handleMenuItemClick = (item) => {
        setSelectedMenuItem(item);
        setIsSideMenuOpen(false);
    };
    const handleLoginWithEmail = () => {
        window.location.href = 'https://gateway.prismax.ai/';

    };

    const handleLogoutWithEmail = () => {

        if (logout()) {
            showNotification('success', "You have successfully logged out of your email account.");

        } else {
            showNotification('error', "An error occurred while logging out of your email account. Please try again.");
        }
        setWalletAddress("Connect Wallet")
    };

    function shortenAddress(address, startLength = 4, endLength = 4) {
        if (!address) return '';
        if (address.length <= startLength + endLength) {
            return address;
        }
        const start = address.slice(0, startLength);
        const end = address.slice(-endLength);
        return `${start}..${end}`;
    }

    function isMobile() {
        return /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    }

    const fetchUserInfoAfterConnect = async (walletAddress) => {
        try {
            if (!isRecaptchaReady) {
                // showNotification('error', 'Security verification not ready. Please try again.');
                return false;
            }
            const recaptchaToken = await executeRecaptchaAction('fetch_user_info');
            const localEmail = localStorage.getItem('userEmail');
            const localToken = localStorage.getItem('gatewayToken');

            const params = new URLSearchParams();
            params.append('wallet_address', walletAddress);
            params.append('recaptcha_token', recaptchaToken);

            if (localEmail && localToken) {
                params.append('email', localEmail);
                params.append('token', localToken);
            }
            const response = await fetch(`${PRISMAX_BACKEND_URL}/api/get-users?${params}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json'
                }
            });
            if (response.ok) {
                const result = await response.json();

                if (result.success && result.data) {
                    if (result.data.user_class) {
                        localStorage.setItem('userClass', result.data.user_class);
                        setUserClass(result.data.user_class)
                    }
                    if (result.data.hash_code) {
                        localStorage.setItem('gatewayToken', result.data.hash_code);
                        setGatewayToken(result.data.hash_code)
                    }
                    if (result.data.userid) {
                        localStorage.setItem('userId', result.data.userid);
                        setUserId(result.data.userid)
                    }
                    if (result.data.total_points) {
                        localStorage.setItem("totalPoints", result.data.total_points);
                    }
                    if (result.data.email) {
                        localStorage.setItem('userEmail', result.data.email);
                        setUserEmail(result.data.email)
                    }
                    return true
                }
            } else {
                const errorResult = await response.json().catch(() => ({}));
                console.log('error')
                if (response.status === 400) {
                    console.error('Binding conflict:', errorResult.msg);
                    showNotification(
                        'error',
                        'This email or wallet address is already linked. Please unlink it before attempting to bind another.'
                    );
                    setShowPanel(false)
                    return false
                } else if (response.status === 403) {
                    showNotification(
                        'error',
                        'Too many login attempts detected. Please wait a moment and try again.'
                    );
                    setShowPanel(false)
                    return false
                } else {
                    showNotification(
                        'error',
                        'Please connect a wallet with a positive SOL balance or log in with your email to continue.'
                    );
                }

            }
        } catch (error) {
            showNotification(
                'error',
                'The server is currently busy. Please try again later.'
            );
            console.error('Error fetching user info:', error);
            return false
        }
    };
    // -----------------------------------------
    // OKX CONNECT & FETCH
    // -----------------------------------------
    const handleOKXWalletSolana = async () => {
        try {
            const provider = window.okxwallet?.solana;
            if (!provider) {
                if (isMobile()) {
                    const encodedDappUrl = encodeURIComponent(APP_URL);
                    const deepLink = "okx://wallet/dapp/url?dappUrl=" + encodedDappUrl;

                    const storeUrl = "https://www.okx.com/download";
                    const start = Date.now();
                    setTimeout(() => {
                        const elapsed = Date.now() - start;
                        if (elapsed < 1500) {
                            window.location.href = storeUrl;
                        }
                    }, 1500);
                    window.location.href = "https://www.okx.com/download?deeplink=" + encodeURIComponent(deepLink);
                    return;
                } else {
                    window.open('https://web3.okx.com/zh-hans/download', '_blank');
                    return
                }
            }
            await provider.connect();
            const publicKey = provider.publicKey?.toString();
            if (!publicKey) {
                showNotification('error', 'Unable to retrieve Solana public key from OKX Wallet.');
                return;
            }

            // Check whitelist and request signature for admin
            if (requireSignature) {
                if (!adminWhitelist.includes(publicKey)) {
                    showNotification('error', 'This wallet is not authorized for admin access.');
                    await provider.disconnect();
                    return;
                }

                try {
                    const adminSignedSignature = await requestSignature(provider, publicKey);

                    const r = await fetch(`${PRISMAX_BACKEND_URL}/api/admin-login`, {
                        method: "POST",
                        headers: {"Content-Type": "application/json"},
                        body: JSON.stringify({wallet_address: publicKey, signature: adminSignedSignature}),
                    });
                    if (!r.ok) throw new Error("Admin login failed");
                    const {access_token} = await r.json();
                    setAdminAccessToken(access_token)
                    localStorage.setItem("prismax_admin_token", access_token)
                    setAdminLogin(true)
                } catch (error) {
                    showNotification('error', 'Signature verification failed. Admin access denied.');
                    await provider.disconnect();
                    return;
                }
            }
            setShowPanel(false)
            // showNotification('success', 'Connecting...')

            // const ok = await fetchBalancesAndNotifyParent(
            //     provider,
            //     publicKey,
            //     onWalletConnected,
            //     showNotification
            // );
            //
            // if (!ok) {
            //     await provider.disconnect?.();
            //     return;
            // }
            const connect_result = await fetchUserInfoAfterConnect(publicKey);
            if (connect_result) {
                setConnectedWalletType("okx");
                localStorage.setItem('lastConnectedWallet', 'okx');
                setWalletAddress(shortenAddress(publicKey));
                localStorage.setItem('walletAddress', publicKey);
                setConnectedPublicKey(publicKey);
                setOkxSolanaProvider(provider);
                setShowPanel(false);
            } else {
                // showNotification('error', 'Server busy. Please try again later.')
                await provider.disconnect?.();
            }
        } catch (error) {
            console.error('Error connecting to OKX Wallet (Solana):', error);
        }
    };

    // -----------------------------------------
    // COINBASE CONNECT & FETCH
    // -----------------------------------------
    const handleCoinbaseWalletSolana = async () => {
        try {
            const provider = window.coinbaseSolana;
            if (!provider) {
                if (isMobile()) {
                    const ua = navigator.userAgent;
                    const isIOS = /iPhone|iPad|iPod/i.test(ua);

                    let coinbaseLink = "";
                    if (isIOS) {
                        coinbaseLink = `cbwallet://dapp?url=${encodeURIComponent(APP_URL)}`;
                    } else {
                        coinbaseLink = `https://go.cb-w.com/dapp?cb_url=${encodeURIComponent(APP_URL)}`;
                    }

                    const storeUrl = "https://www.coinbase.com/en-ca/wallet/downloads";
                    const start = Date.now();
                    setTimeout(() => {
                        const elapsed = Date.now() - start;
                        if (elapsed < 1500) {
                            window.location.href = storeUrl;
                        }
                    }, 1500);

                    window.location.href = coinbaseLink;
                    return;
                } else {
                    window.open('https://www.coinbase.com/wallet', '_blank');
                    return;
                }

            }
            await provider.connect();
            const publicKey = provider.publicKey?.toString();
            if (!publicKey) {
                showNotification('error', 'Unable to retrieve Solana public key from Coinbase Wallet.');
                return;
            }

            // Check whitelist and request signature for admin
            if (requireSignature) {
                if (!adminWhitelist.includes(publicKey)) {
                    showNotification('error', 'This wallet is not authorized for admin access.');
                    await provider.disconnect();
                    return;
                }

                try {
                    await requestSignature(provider, publicKey);
                    setAdminLogin(true)
                } catch (error) {
                    showNotification('error', 'Signature verification failed. Admin access denied.');
                    await provider.disconnect();
                    return;
                }
            }
            setShowPanel(false)
            showNotification('success', 'Connecting...')

            // const ok = await fetchBalancesAndNotifyParent(
            //     provider,
            //     publicKey,
            //     onWalletConnected,
            //     showNotification
            // );
            //
            // if (!ok) {
            //     await provider.disconnect?.();
            //     return;
            // }
            const connect_result = await fetchUserInfoAfterConnect(publicKey);
            if (connect_result) {
                setConnectedWalletType("coinbase");
                localStorage.setItem('lastConnectedWallet', 'coinbase');
                setWalletAddress(shortenAddress(publicKey));
                localStorage.setItem('walletAddress', publicKey);
                setConnectedPublicKey(publicKey);
                setCoinbaseSolanaProvider(provider);
                setShowPanel(false);
            } else {
                // showNotification('error', 'Server busy. Please try again later.')
                await provider.disconnect?.();
            }

        } catch (error) {
            console.error('Error connecting to Coinbase Wallet (Solana):', error);
        }
    };

    // -----------------------------------------
    // WALLETCONNECT CONNECT & FETCH
    // -----------------------------------------
    const handleWalletConnectSolana = async () => {
        try {
            setShowPanel(false);
            await open({view: 'Connect'}); // Opens the WalletConnect modal
            await new Promise(resolve => setTimeout(resolve, 1000));
            if (modalAddress) {

                if (walletProvider) {
                    setShowPanel(false)
                    showNotification('success', 'Connecting...')
                    // const ok = await fetchBalancesAndNotifyParent(
                    //     walletProvider,
                    //     modalAddress,
                    //     onWalletConnected,
                    //     showNotification
                    // );
                    //
                    // if (!ok) {
                    //     await walletProvider.disconnect?.();
                    //     return;
                    // }
                    const connect_result = await fetchUserInfoAfterConnect(modalAddress);
                    if (connect_result) {
                        setConnectedWalletType("walletconnect");
                        localStorage.setItem('lastConnectedWallet', 'walletconnect');
                        localStorage.setItem('walletAddress', modalAddress);

                        setWalletAddress(shortenAddress(modalAddress));

                        setConnectedPublicKey(modalAddress);
                        setWalletConnectProvider(walletProvider);
                    } else {
                        // showNotification('error', 'Server busy. Please try again later.')
                        await walletProvider.disconnect?.();
                    }
                }
                setShowPanel(false);
            } else {
                showNotification('warning', 'WalletConnect connection failed: Please try again.');
            }
        } catch (error) {
            console.error('WalletConnect error:', error);
        }
    };

    const getPhantomProvider = () => {
        let provider = window.phantom?.solana;
        if (!provider) {
            provider = window.solana;
        }
        if (provider && provider.isPhantom) {
            return provider;
        }
        // window.open('https://phantom.app/', '_blank');
        return null;
    };
    const handlePhantomWalletSolana = async () => {
        try {
            const provider = getPhantomProvider();
            if (!provider) {
                if (isMobile()) {
                    const storeUrl = "https://phantom.com/download";
                    const phantomLink = `https://phantom.app/ul/browse/${encodeURIComponent(APP_URL)}?ref=${encodeURIComponent(APP_URL)}`;

                    // 1.5 s still here -> phantom not downloaded
                    const start = Date.now();
                    setTimeout(() => {
                        const elapsed = Date.now() - start;
                        if (elapsed < 1500) {
                            window.location.href = storeUrl;
                        }
                    }, 1500);
                    window.location.href = phantomLink;

                    return;
                } else {
                    window.open('https://phantom.com/', '_blank');
                    return;
                }
            }
            // Request connection to the Phantom Wallet
            await provider.connect();
            const publicKey = provider.publicKey?.toString();
            if (!publicKey) {
                showNotification('error', 'Unable to retrieve Solana public key from Phantom Wallet.');
                return;
            }
            // Check whitelist and request signature for admin
            if (requireSignature) {
                if (!adminWhitelist.includes(publicKey)) {
                    showNotification('error', 'This wallet is not authorized for admin access.');
                    await provider.disconnect();
                    return;
                }

                try {
                    await requestSignature(provider, publicKey);
                    setAdminLogin(true)
                } catch (error) {
                    showNotification('error', 'Signature verification failed. Admin access denied.');
                    await provider.disconnect();
                    return;
                }
            }
            // Update state with Phantom connection details
            setShowPanel(false)
            showNotification('success', 'Connecting...')
            // const ok = await fetchBalancesAndNotifyParent(
            //     provider,
            //     publicKey,
            //     onWalletConnected,
            //     showNotification
            // );
            //
            // if (!ok) {
            //     await provider.disconnect?.();
            //     return;
            // }
            const connect_result = await fetchUserInfoAfterConnect(publicKey);
            if (connect_result) {
                setConnectedWalletType("phantom");
                localStorage.setItem('lastConnectedWallet', 'phantom');
                setWalletAddress(shortenAddress(publicKey));
                localStorage.setItem('walletAddress', publicKey);
                setConnectedPublicKey(publicKey);
                setPhantomSolanaProvider(provider);
                setShowPanel(false);
            } else {
                // showNotification('error', 'Server busy. Please try again later.')
                await provider.disconnect?.();
            }

        } catch (error) {
            console.error('Error connecting to Phantom Wallet (Solana):', error);
        }
    };

    function verifyBalanceBeforeTransaction({
                                                selectedToken,
                                                amount,
                                                usdcBalance,
                                                usdtBalance
                                            }) {
        const needed = Number(amount) || 0;
        if (selectedToken === 'USDC' && needed > usdcBalance) {
            return false;
        }
        if (selectedToken === 'USDT' && needed > usdtBalance) {
            return false;
        }
        return true
    }

    // -----------------------------------------
    // TRANSFER LOGIC
    // -----------------------------------------
    const handleSolanaTransaction = async (RECEIVING_TOKEN_ACCOUNT = null) => {
        if (!connectedPublicKey) {
            return;
        }
        let providerToUse = null;
        if (connectedWalletType === 'okx') {
            providerToUse = okxSolanaProvider;
        } else if (connectedWalletType === 'coinbase') {
            providerToUse = coinbaseSolanaProvider;
        } else if (connectedWalletType === 'phantom') {
            providerToUse = phantomSolanaProvider;
        } else if (connectedWalletType === 'walletconnect') {
            providerToUse = walletConnectProvider;
        }
        const {
            usdcBalance,
            usdtBalance,
        } = await fetchTokenBalances(providerToUse, connectedPublicKey);
        setUsdtBalance(usdtBalance)
        setUsdcBalance(usdcBalance)
        const verificationResult = verifyBalanceBeforeTransaction({
            selectedToken,
            amount,
            usdcBalance,
            usdtBalance,
        });
        if (!verificationResult) {
            showNotification('warning', `Insufficient ${selectedToken} Balance`);
            setIsProcessing(false)
            return;
        }
        await transferSplToken(connectedPublicKey, providerToUse, selectedToken, null);
    };

    const transferSplToken = async (fromPublicKeyStr, provider, tokenType, C2C_RECEIVING_TOKEN_ACCOUNT) => {
        try {
            const connection = new Connection(RPC_URL, "confirmed");
            const fromPublicKey = new PublicKey(fromPublicKeyStr);
            let tokenMintAddress;
            let toTokenAccountPubkey;
            let readableToken;
            if (tokenType === 'USDT') {
                tokenMintAddress = usdtTokenAddress;
                readableToken = "USDT";
                const toTokenAddress = await getTokenAccountFromWalletAddress(prismaxRecevingAddress, usdtTokenAddress)
                toTokenAccountPubkey = new PublicKey(toTokenAddress);
            } else if (tokenType === 'USDC') {
                tokenMintAddress = usdcTokenAddress;
                readableToken = "USDC";
                const toTokenAddress = await getTokenAccountFromWalletAddress(prismaxRecevingAddress, usdcTokenAddress)
                toTokenAccountPubkey = new PublicKey(toTokenAddress);
            } else {
                showNotification('error', "Unknown token type. Canceling transaction.");
                return;
            }

            const latestBlockhash = await connection.getLatestBlockhash("confirmed");
            let signature;

            // prepare a signer object
            const payer = {
                publicKey: fromPublicKey,
                signTransaction: async (transaction) => {
                    return await provider.signTransaction(transaction);
                },
            };

            const mintPubkey = new PublicKey(tokenMintAddress);
            const fromTokenAccount = await getOrCreateAssociatedTokenAccount(
                connection,
                payer,
                mintPubkey,
                fromPublicKey
            );
            const amountInBaseUnits = Math.floor(Number(amount) * 1_000_000);
            if (isNaN(amountInBaseUnits) || amountInBaseUnits <= 0) {
                showNotification('error', `Invalid ${readableToken} amount. Please provide a positive number.`);
                return;
            }
            // Create the transfer instruction
            const transferIx = createTransferInstruction(
                fromTokenAccount.address,
                toTokenAccountPubkey,
                fromPublicKey,
                amountInBaseUnits
            );

            const memoText = `Send ${amount} ${readableToken} to ${toTokenAccountPubkey.toBase58()}`;
            const memoIx = new TransactionInstruction({
                keys: [],
                programId: new PublicKey('MemoSq4gqABAXKb96qnH8TysNcWxMyWCqXgDLGmfcHr'),
                data: Buffer.from(memoText, 'utf8'),
            });

            // Build the transaction with transfer + memo
            const transaction = new Transaction().add(transferIx).add(memoIx);
            transaction.feePayer = fromPublicKey;
            transaction.recentBlockhash = latestBlockhash.blockhash;

            const result = await provider.signAndSendTransaction(transaction);
            signature = result.signature;
            console.log("signature", signature);

            const explorerLink = `https://solscan.io/tx/${signature}`;
            showNotification('success', `Transfer of ${amount} ${readableToken} successfully submitted.
                 <a href="${explorerLink}" target="_blank" rel="noreferrer">Check on Explorer</a>`);

            await new Promise(resolve => setTimeout(resolve, 3000));
            console.log("got here fetchBalancesAndNotifyParent")
            await fetchBalancesAndNotifyParent(provider, fromPublicKeyStr, onWalletConnected);
            try {

                const requestBody = {
                    wallet_address: fromPublicKeyStr,
                    amount_total: amount,
                    user_id: localStorage.getItem('userId'),
                    solana_transaction_hash: signature,
                    currency: selectedToken
                };

                const response = await fetch(`${PRISMAX_BACKEND_URL}/api/record-crypto-payment`, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify(requestBody)
                });
                const data = await response.json();
                if (data.success) {
                    onMembershipPaymentSuccess(data.solana_transaction_hash);

                }
                if (!response.ok) {
                    throw new Error(`Server responded with status ${response.status}`);
                }

                // showNotification('success', `Cash received of ${amount} ${selectedToken.toUpperCase()} .
                //          <a href="${explorerLink}" target="_blank" rel="noreferrer">Check on Explorer</a>`);
            } catch (error) {
                showNotification('error', `Upgrading error, please contact support through the Discord ticket channel.`);
            }

        } catch (err) {
            console.error(`Error transferring token on Solana:`, err);
            if (err?.code === 4001) {
                showNotification('error', "User rejected the transaction.");
                setIsProcessing(false)
            } else {
                if (err && err.message) {
                    console.log(" error!", err)
                    showNotification('error', `Transaction failed: ${err.message}`);
                } else {
                    console.log("error! ", err);
                    showNotification('error', 'Transaction failed, please try again');
                }
            }
        }
    };


    // DISCONNECT
    const disconnectWallet = async () => {
        try {
            if (okxSolanaProvider && okxSolanaProvider.disconnect) {
                okxSolanaProvider.disconnect();
            }
            if (coinbaseSolanaProvider) {
                await window.coinbaseSolana.disconnect();
            }
            if (walletConnectProvider && walletConnectProvider.disconnect) {
                await walletConnectProvider.disconnect();
            }
            if (phantomSolanaProvider && phantomSolanaProvider.disconnect) {
                await phantomSolanaProvider.disconnect();
            }
            setConnectedPublicKey(null);
            setWalletAddress("Connect Wallet");

            setOkxSolanaProvider(null);
            setCoinbaseSolanaProvider(null);
            setWalletConnectProvider(null);
            setPhantomSolanaProvider(null);
            setShowPanel(false);
            setConnectedWalletType(null);
            if (setAdminLogin) {
                setAdminLogin(false)
            }
            setUserClass('Explorer Member')
            localStorage.clear();
            clearUserData()
            if (onWalletConnected) {
                onWalletConnected(null, 0, 0, 0);
            }
            showNotification('success', 'Your wallet has been successfully disconnected.')


        } catch (err) {
            console.error("Error disconnecting wallet:", err);
        }
    };


    return (
        <div
            className={styles.outerContainer}
            onClick={handleOutsideClick}
        >
            <img
                className={styles.menu_mobile_icon}
                src={menu_icon}
                style={{width: '22px', height: '22px'}}
                alt="Menu"
                onClick={handleMenuIconClick}
            />
            <img
                className={styles.vectorIcon}
                src={logo_svg}
                alt="PrismaX AI"
            />


            {notification.message ? (
                <div className={styles.transactionErrorBoxWapper}>
                    <div className={styles.transactionErrorBox}>
                        <div className={styles.transactionErrorContent}>
                            <img
                                src={
                                    notification?.status === 'error'
                                        ? rejectImg
                                        : notification?.status === 'warning'
                                            ? warningImg
                                            : successImg
                                }
                                alt={notification.status || 'status'}
                                className={styles.rejectIcon}
                            />
                            <span
                                className={styles.errorMessage}
                                dangerouslySetInnerHTML={{__html: notification.message}}
                            />
                        </div>
                        <img
                            className={styles.cancelBtn}
                            src={cancle_icon}
                            alt="x"
                            onClick={() => showNotification(null, null)}
                        />
                    </div>
                </div>
            ) : (
                <div className={styles.container} >

                    {isSideMenuOpen ? (
                        <SideMenu
                            isOpen={isSideMenuOpen}
                            selectedMenuItem={selectedMenuItem}
                            onMenuItemClick={handleMenuItemClick}
                            onOverlayClick={handleOutsideClickSideMenu}
                            stopPropagation={(e) => e.stopPropagation()}
                        />
                    ) : (
                        <div
                            className={styles.userIconContainer}
                            onClick={(e) => e.stopPropagation()}
                        >
                            <div
                                className={
                                    `${styles.userIcon} ` +
                                    (
                                        walletAddress === "Connect Wallet"
                                            ? styles.userIconNoHover
                                            : styles.userIconRedHover
                                    )
                                }
                                onClick={handleConnectWalletClick}
                                style={{
                                    background:
                                        walletAddress === "Connect Wallet"
                                            ? "white"
                                            : "#32353D",
                                    color:
                                        walletAddress === "Connect Wallet"
                                            ? "black"
                                            : "white",
                                    borderRadius: "10px",
                                    width: "151px"
                                }}
                            >
                                {walletAddress === "Connect Wallet"
                                    ? ""
                                    : connectedWalletType === "okx"
                                        ? (
                                            <img
                                                style={{
                                                    borderRadius: '50%',
                                                    width: '18px',
                                                    height: '18px',
                                                    marginRight: '8px',
                                                    marginLeft: '0px'
                                                }}
                                                src={okx_icon}
                                                alt="OKX"
                                            />
                                        ) : connectedWalletType === "coinbase"
                                            ? (
                                                <img
                                                    style={{
                                                        borderRadius: '50%',
                                                        width: '18px',
                                                        height: '18px',
                                                        marginRight: '8px',
                                                        marginLeft: '0px'
                                                    }}
                                                    src={coinbase_icon}
                                                    alt="Coinbase"
                                                />
                                            ) : connectedWalletType === "walletconnect"
                                                ? (
                                                    <img
                                                        style={{
                                                            borderRadius: '50%',
                                                            width: '18px',
                                                            height: '18px',
                                                            marginRight: '8px',
                                                            marginLeft: '0px'
                                                        }}
                                                        src={walletconnect_icon}
                                                        alt="WalletConnect"
                                                    />
                                                ) : connectedWalletType === "phantom"
                                                    ? (
                                                        <img
                                                            style={{
                                                                borderRadius: '50%',
                                                                width: '18px',
                                                                height: '18px',
                                                                marginRight: '8px',
                                                                marginLeft: '0px'
                                                            }}
                                                            src={Phantom_icon}
                                                            alt="Phantom"
                                                        />
                                                    ) : null
                                }
                                {walletAddress}
                                {walletAddress === "Connect Wallet" ? '' : (
                                    <img
                                        style={{
                                            borderRadius: '50%',
                                            width: '20px',
                                            height: '20px',
                                            marginRight: '0px',
                                            marginLeft: '8px',
                                            background: 'none',
                                            marginTop: '3px',
                                        }}
                                        className={styles.downArrow}
                                        src={menuDropDownImg}
                                        alt="arrow"
                                    />
                                )}
                            </div>


                            {showPanel && (
                                <div
                                    className={styles.overlay}
                                    onClick={handleOutsideClick}
                                ></div>
                            )}

                            <div
                                className={
                                    `${styles.sidePanel} ` +
                                    (showPanel
                                        ? ((connectedPublicKey && !userEmail) ? styles.openConnected : styles.openNotConnected)
                                        : '')
                                }
                                style={{"width": "352px"}}
                                onClick={stopPropagation}
                            >
                                <div className={styles.connectHeader}>
                                    <h3>Connect</h3>
                                    <div
                                        className={styles.closeBtn}
                                        onClick={closePanel}
                                        aria-label="Close"
                                    >
                                        ×
                                    </div>
                                </div>

                                <div className={styles.lineWrapper}>
                                    <div className={styles.dividerLineFull}></div>
                                </div>

                                <div style={{background: "#1c1c1c"}}>
                                    {/* OKX */}
                                    <div className={styles.connectOption} onClick={handleOKXWalletSolana}>
                                        <img className={styles.walletIcon} src={isMobile ? okx_icon_mobile : okx_icon}
                                             alt="OKX"/>
                                        <div className={styles.walletType}><p>OKX Wallet</p>
                                            {isOkxDetected && <div className={styles.detect}>detected</div>}
                                        </div>
                                    </div>
                                    {/* WalletConnect：no need to detect */}
                                    <div className={styles.connectOption} onClick={handleWalletConnectSolana}>
                                        <img className={styles.walletIcon}
                                             src={isMobile ? walletconnect_icon_mobile : walletconnect_icon}
                                             alt="WalletConnect"/>
                                        <p>WalletConnect</p>
                                    </div>

                                    {/* Coinbase */}
                                    <div className={styles.connectOption} onClick={handleCoinbaseWalletSolana}>
                                        <img className={styles.walletIcon}
                                             src={isMobile ? coinbase_icon_mobile : coinbase_icon}
                                             alt="Coinbase"/>
                                        <div className={styles.walletType}><p>Coinbase Wallet</p>
                                            {isCoinbaseDetected && <div className={styles.detect}>detected</div>}
                                        </div>
                                    </div>

                                    {/* Phantom */}
                                    <div className={styles.connectOption} onClick={handlePhantomWalletSolana}>
                                        <img className={styles.walletIcon}
                                             src={isMobile ? Phantom_icon_mobile : Phantom_icon}
                                             alt="Phantom"/>
                                        <div className={styles.walletType}><p>Phantom Wallet</p>
                                            {isPhantomDetected && <div className={styles.detect}>detected</div>}
                                        </div>
                                    </div>
                                    {connectedPublicKey && !userEmail && (
                                        <div className={styles.lineWrapper}>
                                            <div className={styles.dividerLineFullLower}></div>
                                        </div>
                                    )}

                                    {connectedPublicKey && !userEmail && (
                                        <div
                                            className={styles.connectOption}
                                            onClick={disconnectWallet}
                                            style={{paddingTop: "10px", paddingBottom: '10px'}}
                                        >
                                            <img style={{width: "30px", height: "30px"}}
                                                 className={styles.walletIcon}
                                                 src={disconnectImg} alt="disconnect"/>
                                            <p style={{color: 'red', lineHeight: "30px"}}>Disconnect</p>
                                        </div>
                                    )}

                                    <div className={styles.lineWrapper}>
                                        <div className={styles.dividerLine}></div>
                                        <div className={styles.or}>Or</div>
                                        <div className={styles.dividerLine}></div>
                                    </div>

                                    {/* Email */}
                                    {userEmail ? (
                                        <div className={styles.connectOption}>
                                            <img
                                                style={{marginRight: '17px', width: '30px'}}
                                                src={email_svg}
                                                alt="email"
                                            />
                                            <div className={styles.emailType} onClick={handleLogoutWithEmail}>
                                                <p>{userEmail}</p>
                                                <img
                                                    style={{marginRight: '17px'}}
                                                    src={emailLogoutImg}
                                                    alt="email"
                                                />
                                            </div>
                                        </div>
                                    ) : (
                                        <div
                                            className={styles.connectOption}
                                            onClick={handleLoginWithEmail}
                                        >
                                            <img
                                                style={{marginRight: '17px', width: '30px'}}
                                                src={email_svg}
                                                alt="email"
                                            />
                                            <p>Log in with Email</p>
                                        </div>
                                    )}

                                </div>
                            </div>
                        </div>
                    )}
                </div>
            )}
        </div>
    );
};

export default ConnectWalletHeader;